import { PAYPAL_THEME } from '@paypalcorp/pp-react'
import { greyBackgroundAndSmaller } from 'lib/styles/media-queries'
import { StyleSheet } from '../paypalphrodite'
import glamorous from 'glamorous'

const {
  sysColorSecondaryMain,
  sysColorPrimaryMainHover,
  sysColorStructureBorderLowContrast,
} = PAYPAL_THEME

export const BOX_BORDER_STYLES = {
  border: `1px solid ${sysColorStructureBorderLowContrast}`,
  borderRadius: '0.875rem',
  [greyBackgroundAndSmaller]: {
    border: 'none',
    borderRadius: 0,
  },
}

export const PRIMARY_TEXT_FONT_FAMILY = {
  fontFamily: 'PayPalOpen-Regular, "Helvetica Neue", Arial, sans-serif',
}

export const LINK_STYLES = {
  '&:hover': {
    color: sysColorPrimaryMainHover,
  },
  color: sysColorSecondaryMain,
  fontFamily: 'PayPalOpen-Bold, "Helvetica Neue", Arial, sans-serif',
}

export const CardStyles = StyleSheet.create({
  container: {
    width: '100%',
    lineHeight: 'normal',
    '-webkit-text-stroke-width': 'unset',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    padding: 0,
    maxWidth: 500,
  },
  headingText: {
    textAlign: 'center',
    marginBottom: '24px',
  },
  bodyText: {
    textAlign: 'start',
  },
})

export const ButtonWrapper = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  margin: '24px 0',
})
